import React from "react"

import "./biError.scss"

const BIError = (props) => {
  return <div className="bi-error-message">Unable to load BI model.</div>
}

export default BIError
